import React, { useContext, useEffect, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { observer } from 'mobx-react-lite';
import { Context } from '../index';
import TypeBar from '../components/TypeBar';
import BrandBar from '../components/BrandBar';
import DeviceList from '../components/DeviceList';
import Pagination from '../components/Pagination';
import { fetchTypes, fetchBrands, fetchDevices } from '../http/deviceAPI';

const Shop = observer(() => {
    const { device } = useContext(Context);
    const [loading, setLoading] = useState(false);

    const loadData = async () => {
        setLoading(true);
        try {
            const types = await fetchTypes();
            const brands = await fetchBrands();
            
            const devices = await fetchDevices(
                device.selectedType.id,
                device.selectedBrand.id,
                device.page,
                device.limit
            );
            
            device.setTypes(types);
            device.setBrands(brands);
            device.setDevices(devices.rows);
            device.setTotalCount(devices.count);
        } catch (error) {
            console.error('Ошибка загрузки:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [device.page, device.selectedType, device.selectedBrand]);

    const setPage = (page) => {
        device.setPage(page);
    };

    return (
        <Container fluid className="px-2 px-md-3">
            <Row className='mt-2 g-2'>
                <Col xs={12} md={3} className="mb-3 mb-md-0">
                    <TypeBar />
                </Col>
                <Col xs={12} md={9}>
                    <BrandBar />
                    {loading ? (
                        <div className="text-center mt-4">Загрузка...</div>
                    ) : (
                        <>
                            <DeviceList />
                            <Pagination
                                totalCount={device.totalCount}
                                limit={device.limit}
                                page={device.page}
                                setPage={setPage}
                            />
                        </>
                    )}
                </Col>
            </Row>
        </Container>
    );
});

export default Shop;
